import { useState } from "react";
import { Bug } from "lucide-react";
import { cn } from "@repo/exit-calc-web-utils";
import { toastService } from "@mobile/features/toast/toast-service";
import { modalService } from "@mobile/features/modal";
import { Button } from "@mobile/components/ui/button";

export function DebugPanel() {
  const [isOpen, setIsOpen] = useState(false);

  if (!import.meta.env.DEV) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={cn(
          "fixed left-2 z-50 flex h-8 w-8 items-center justify-center rounded-full bg-muted shadow-md",
          isOpen ? "opacity-50" : "opacity-100",
        )}
        style={{ bottom: "calc(56px + 28px + var(--safe-area-inset-bottom))" }}
      >
        <Bug className="h-4 w-4" />
      </button>

      {isOpen && (
        <div
          className="fixed left-2 right-2 z-50 rounded-lg border bg-background p-3 shadow-xl"
          style={{
            bottom: "calc(56px + 64px + var(--safe-area-inset-bottom))",
          }}
        >
          <p className="mb-2 text-xs font-semibold text-muted-foreground">
            Debug Panel
          </p>

          <div className="mb-2">
            <p className="mb-1 text-xs text-muted-foreground">Toast</p>
            <div className="flex flex-wrap gap-1.5">
              <Button
                size="sm"
                variant="outline"
                onClick={() => toastService.success("성공 메시지")}
              >
                Success
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={() => toastService.error("에러 메시지")}
              >
                Error
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={() => toastService.warning("경고 메시지")}
              >
                Warning
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={() => toastService.info("정보 메시지")}
              >
                Info
              </Button>
            </div>
          </div>

          <div>
            <p className="mb-1 text-xs text-muted-foreground">Modal</p>
            <div className="flex flex-wrap gap-1.5">
              <Button
                size="sm"
                variant="outline"
                onClick={() => modalService.confirm("확인하시겠습니까?")}
              >
                Confirm
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={() => modalService.alert("알림 메시지입니다.")}
              >
                Alert
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={() =>
                  modalService.destructive("정말 삭제하시겠습니까?")
                }
              >
                Destructive
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
